import React from 'react';
import ReactDOM from 'react-dom';
import PricingModel from './components/App/PricingModel';
import RecipePage from './components/App/RecipePage';
import RecipeContext from "./context/RecipeContext";
import $ from 'jquery';
import { BrowserRouter as Router} from "react-router-dom";
import "./index.css"

$(function() {
   	$('.react-pricing-model').each(function() {
	    let dom = $(this)[0];
	    ReactDOM.render(<PricingModel/>, dom);
	});
});

$(function() {
	$('.react-recipe-page').each(function() {
	 let dom = $(this)[0];
	 ReactDOM.render(
		<>
	 		<Router>
			 	<RecipeContext>
					<RecipePage />
				</RecipeContext>
			</Router>
		</>,
	dom);
 });
});